const drawerBackdropMotion = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
}

const drawerPanelMotion = {
  hidden: { x: '100%' },
  visible: { x: 0 },
}

export { drawerBackdropMotion, drawerPanelMotion }
